module.exports = __webpack_public_path__ + "static/media/plantPal2_13.73087b5f.png";